import React, {Component} from 'react';
import {Col, Row} from 'reactstrap';

const packageJSON = require('../../package.json')

class Footer extends Component {

  render() {
    return (
      <Row className="footer">
        <Col md={12}>
          <h6>PHHS Loss of Privileges List<br/>
            Copyright {packageJSON.copyright}<br/>
            <a href="https://docs.google.com/document/d/1DL2hkbq6USGRnWJKw7p9V8b6Sj_F4gO_A9jgZf0m5E0" target="_blank" rel="noopener noreferrer">Instructions</a><br/>
            Version {packageJSON.version}
          </h6>
        </Col>
      </Row>
    )
  }

}

export default Footer



// WEBPACK FOOTER //
// ./src/views/Footer.js